import { Component, Input, OnInit } from '@angular/core';
import { Question, Questions } from "./question.model";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { FormService } from "../../../services/form.service";

@Component( {
	selector: 'app-question',
	templateUrl: './question.component.html',
	styleUrls: ['./question.component.scss']
} )
export class QuestionComponent implements OnInit {

	@Input() question!: Question;
	@Input() questionIndex!: number;
	public thirdPartyForm !: UntypedFormGroup
	public questions : Questions | undefined;
	public questionKey!: number;
	formGroupName : string = 'thirdPartyForm'

	constructor( private formService: FormService ) {
	}

	ngOnInit(): void {

		this.questionKey = this.question.key;

		this.thirdPartyForm = this.formService.thirdPartyForm as UntypedFormGroup;
		this.questions = this.formService.questions;
	}

	// This function sets the validators for the sub questions
	public checkAndSetRequired( mainQuestionKey: number, questionIndex: number ) : void {

		// Get value from current control
		var mainQuestionValue = this.thirdPartyForm.controls['question_'+mainQuestionKey].value;

		// Get current control
		var mainQuestion = this.questions![questionIndex as keyof Questions] as Question;

		// Loop for sub questions
		for( let subQuestionNumber of [1,2,3] ) {

			// Question types
			// 0 = no extra question
			// 1 = text
			// 2 = select
			var questionType = (<string>mainQuestion['extra_' + subQuestionNumber + '_type' as keyof Question] );

			// Check if there is a subQuestion with this number
			if( questionType === '0' ) {
				break;
			}

			var shouldRequired = (<string>mainQuestion['extra_' + subQuestionNumber + '_class' as keyof Question] ).includes( 'required' );
			var subQuestionName = 'question_' + mainQuestionKey + '_' + subQuestionNumber;

			// Set to required or not depending on value
			if( shouldRequired ) {

				var subQuestionControl = (<UntypedFormControl>this.thirdPartyForm.controls[subQuestionName] );

				// If mainQuestionValue is yes
				if( mainQuestionValue === '1' ) {

					// Reset first
					subQuestionControl.reset();

					// If the extra question is a text input
					if( questionType === '1' ) {

						subQuestionControl.addValidators( [Validators.required, Validators.minLength( 3 ) ]);
					}
					else if( questionType === '2' ) {

						subQuestionControl.addValidators( [Validators.required]);
					}
				}
				else {

					subQuestionControl.clearValidators();
					subQuestionControl.reset();
				}
				subQuestionControl.updateValueAndValidity();
			}
		}
	}
}
